/*jshint browserify: true */
'use strict';

var PdfElement = require('./pdf-element.js');

/**
 * @name PdfImageElement
 *
 * An image element will render an image on-top of a PDF page.
 */
var PdfImageElement = (function PdfImageElementClosure() {
    function PdfImageElement() {
        PdfElement.call(this);

        this.placeHolder = '';
    }

    PdfImageElement.prototype = Object.create(PdfElement.prototype);
    PdfImageElement.prototype.constructor = PdfImageElement;

    return PdfImageElement;
})();

PdfImageElement.prototype.renderToCanvas = function (pdfViewport, canvasContext, selected, mousePosition, interactionMode) {
    PdfElement.prototype.renderToCanvas.call(this, pdfViewport, canvasContext, selected, mousePosition, interactionMode);

    var translatedRectangle = coordinates.translatePdfRectangleToViewportRectangle(pdfViewport, this);
    
    var img = new Image();
    img.src = imagePlaceholder.dataUriPreamble +imagePlaceholder.base64content;

    canvasContext.save();
    canvasContext.globalAlpha = 0.5;
    renderImageInCentre(img, canvasContext, translatedRectangle.x, translatedRectangle.y, translatedRectangle.width, translatedRectangle.height, imagePlaceholder.width, imagePlaceholder.height);
    canvasContext.restore();
};

module.exports = PdfImageElement;

var coordinates = require('../Coordinates');
var renderImageInCentre = require('../render-image-in-centre.js');
var imagePlaceholder = require('../image-placeholder.js');